@if (forecast(); as forecast) {
  <div class="forecast-info">
    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">
        {{ 'forecastInfo.stockPricePredictions.marketExpectations' | translate }}
      </h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">
            {{ 'forecastInfo.stockPricePredictions.epsForecastProximilar' | translate }}:
          </p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="eps_forecast_proximilar"
            >
              {{ forecast.epsForecastProximilar | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">
            {{ 'forecastInfo.stockPricePredictions.salesForecastProximilar' | translate }}:
          </p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="sales_forecast_proximilar"
            >
              {{ forecast.salesForecastProximilar | forecastNumber: -1 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">
            {{ 'forecastInfo.stockPricePredictions.epsSurpriseForecast' | translate }}:
          </p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="eps_surprise_forecast"
            >
              {{ forecast.epsSurpriseForecast | forecastNumber: 3 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">
            {{ 'forecastInfo.stockPricePredictions.salesSurpriseForecast' | translate }}:
          </p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="sales_surprise_forecast"
            >
              {{ forecast.salesSurpriseForecast | forecastNumber: 0 : true }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>

    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">
        {{ 'forecastInfo.postReleasePriceMove' | translate }}
        <span class="seperator">-</span>

        @switch (postReleaseRisk) {
          @case (EForecastRisk.LOW) {
            <span class="risk low-risk">{{ 'forecastInfo.risk.low' | translate }}</span>
          }
          @case (EForecastRisk.MEDIUM) {
            <span class="risk medium-risk">
              {{ 'forecastInfo.risk.medium' | translate }}
            </span>
          }
          @case (EForecastRisk.HIGH) {
            <span class="risk high-risk">
              {{ 'forecastInfo.risk.high' | translate }}
            </span>
          }
          @case (EForecastRisk.VERY_HIGH) {
            <span class="risk very-high-risk">
              {{ 'forecastInfo.risk.veryHigh' | translate }}
            </span>
          }
        }
      </h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.postReleaseOvernightMoveTitle' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="post_release_overnight_move"
            >
              ±{{ forecast.postReleaseOvernightMove | forecastPercentNumber: 1 }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.postRelease1weekMoveTitle' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="post_release_1_week_move"
            >
              ±{{ forecast.postRelease1weekMove | forecastPercentNumber: 0 }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>

    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">{{ 'forecastInfo.expectedPriceImpact' | translate }}</h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.impactAtConsensus' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="impact_at_consensus"
            >
              {{ forecast.company?.addlPred?.impactAtConsensus | forecastPercentNumber: 1 }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">
            {{ 'forecastInfo.stockPricePredictions.impactAtProxForecast' | translate }}:
          </p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="impact_at_prox_forecast"
            >
              {{ forecast.company?.addlPred?.impactAtProxForecast | forecastPercentNumber: 1 }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>

    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">{{ 'forecastInfo.confidenceIntervals' | translate }}</h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.surpEpsStd' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="surp_eps_std"
            >
              {{ forecast.company?.addlPred?.surpEpsStd | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.surpRevStd' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="surp_rev_std"
            >
              {{ forecast.company?.addlPred?.surpRevStd | forecastNumber: 0 : true }}
            </app-user-access>
          </p>
        </div>
        @if (forecast.company?.addlPred?.corrPred !== undefined) {
          <div class="item">
            <p class="forecast-item-header">{{ 'addlPred.epsStd' | translate }}:</p>
            <p class="forecast-item-value">
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="eps_std"
              >
                {{ forecast.company?.addlPred?.epsStd | forecastPercentNumber: 2 }}
              </app-user-access>
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="eps_std_rating"
              >
                <span class="risk">
                  @switch (forecast.company?.addlPred?.epsStdRating) {
                    @case (EForecastRisk.LOW) {
                      <span class="risk low-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.MEDIUM) {
                      <span class="risk medium-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.HIGH) {
                      <span class="risk high-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.VERY_HIGH) {
                      <span class="risk very-high-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.EXTREME_UNCERTAINTY) {
                      <span class="risk extreme-uncertainty-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                  }
                </span>
              </app-user-access>
            </p>
          </div>
        }
        @if (forecast.company?.addlPred?.revStd !== undefined) {
          <div class="item">
            <p class="forecast-item-header">{{ 'addlPred.revStd' | translate }}:</p>
            <p class="forecast-item-value">
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="rev_std"
              >
                {{ forecast.company?.addlPred?.revStd | forecastPercentNumber: 2 }}
              </app-user-access>
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="rev_std_rating"
              >
                <span class="risk">
                  @switch (forecast.company?.addlPred?.revStdRating) {
                    @case (EForecastRisk.LOW) {
                      <span class="risk low-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.MEDIUM) {
                      <span class="risk medium-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.HIGH) {
                      <span class="risk high-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.VERY_HIGH) {
                      <span class="risk very-high-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.EXTREME_UNCERTAINTY) {
                      <span class="risk extreme-uncertainty-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                  }
                </span>
              </app-user-access>
            </p>
          </div>
        }
      </div>
    </div>
  </div>
}
